import { BrowserModule } from '@angular/platform-browser';
import { DEFAULT_CURRENCY_CODE, ErrorHandler, LOCALE_ID, NgModule } from '@angular/core';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import { IconsProviderModule } from './icons-provider.module';
import { NzLayoutModule } from 'ng-zorro-antd/layout';
import { NzMenuModule } from 'ng-zorro-antd/menu';
import { FormsModule } from '@angular/forms';
import { provideHttpClient, withInterceptorsFromDi } from '@angular/common/http';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NZ_I18N, NZ_DATE_CONFIG } from 'ng-zorro-antd/i18n';
import { nzDeDE } from './core/i18n/nz-de-de';
import { AppErrorHandler } from './core/services/AppErrorHandler';
import { registerLocaleData } from '@angular/common';
import de from '@angular/common/locales/de';
import { CoreModule } from './core/core.module';
import { ServiceWorkerModule } from '@angular/service-worker';
import { environment } from '../environments/environment';
import { ProductionOrdersModule } from './pages/production-orders/production-orders.module';
import { OrdersModule } from './pages/orders/orders.module';
import { StoresModule } from './pages/stores/stores.module';
import { NzAvatarModule } from 'ng-zorro-antd/avatar';
import { UiModule } from './ui/ui.module';
import { UsersModule } from './pages/users/users.module';
import { BulkContainersModule } from './pages/bulk-containers/bulk-containers.module';
import { StockTransferModule } from './pages/stock-transfer/stock-transfer.module';
import { StaticDependenciesService } from './core/services';
import { StorestocksModule } from './pages/stores-stocks/storestocks.module';
import { ArticlesModule } from './pages/articles/articles.module';
import { SharedModule } from './shared/shared.module';
import { NzTooltipDirective } from 'ng-zorro-antd/tooltip';
import { DragulaModule } from 'ng2-dragula';

registerLocaleData(de);
registerLocaleData(de, 'de-DE');

@NgModule({ declarations: [
        AppComponent
    ],
    bootstrap: [AppComponent], imports: [BrowserModule,
        AppRoutingModule,
        IconsProviderModule,
        NzLayoutModule,
        NzMenuModule,
        FormsModule,
        BrowserAnimationsModule,
        CoreModule,
        ServiceWorkerModule.register('ngsw-worker.js', { enabled: environment.isSW }),
        ProductionOrdersModule,
        OrdersModule,
        StoresModule,
        StockTransferModule,
        NzAvatarModule,
        UiModule,
        UsersModule,
        BulkContainersModule,
        StorestocksModule,
        ArticlesModule,
        SharedModule,
        NzTooltipDirective,
        DragulaModule.forRoot()], providers: [
        { provide: LOCALE_ID, useValue: 'de-DE' },
        { provide: NZ_I18N, useValue: nzDeDE },
        { provide: NZ_DATE_CONFIG, useValue: { firstDayOfWeek: 1 } },
        { provide: DEFAULT_CURRENCY_CODE, useValue: 'EUR' },
        { provide: ErrorHandler, useClass: AppErrorHandler },
        StaticDependenciesService,
        provideHttpClient(withInterceptorsFromDi())
    ] })
export class AppModule {
  constructor(
    private readonly _staticDependenciesService: StaticDependenciesService
  ) {}
}
